/** @jsx jsx */
import { Status, TabButtonVertical } from "@eworkit/iris";
import { FC } from "react";
import { jsx } from "theme-ui";

import { RelatedEntities, RelatedEntityKey } from "@/data/related";

import { useRelatedEntitiesNav } from "./RelatedEntitiesNavContext";
import { useRelatedEntitiesTabsData } from "./useRelatedEntitiesTabsData";

interface RelatedEntitiesTabButtonProps {
  relatedKey: RelatedEntityKey;
  relatedEntities: RelatedEntities;
}

export const RelatedEntitiesTabButton: FC<RelatedEntitiesTabButtonProps> = ({ relatedKey, relatedEntities }) => {
  const { activeTab, setActiveTab } = useRelatedEntitiesNav();
  const tabsData = useRelatedEntitiesTabsData(relatedEntities);

  return (
    <TabButtonVertical
      as="div"
      onClick={() => setActiveTab(relatedKey)}
      active={relatedKey === activeTab}
      placeholderLeft={tabsData[relatedKey].icon}
      activeStatePlaceholderLeft={tabsData[relatedKey].activeIcon}
      placeholderRight={<Status>{tabsData[relatedKey].count}</Status>}>
      {tabsData[relatedKey].label}
    </TabButtonVertical>
  );
};
